import L, { Icon } from 'leaflet';
import activity from './activite-arrow.png';
import airbnb from './airbnb.svg';
import booking from './booking.svg';
import greengo from './greengo.svg';
import icon from './marker.svg';
import museum from './museum.svg';
import tripadvisor from './tripadvisor.svg';
import villageFrance from './village-france.svg';

const iconDolcevia = new Icon.Default({
  imagePath: new String('') as string,
  iconUrl: icon.src,
  iconRetinaUrl: icon.src,
  iconAnchor: [30, 55],
  iconSize: new L.Point(60, 75),
});

const iconBooking = new L.Icon({
  iconUrl: booking.src,
  iconAnchor: [30, 55],
  popupAnchor: [0, -20],
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: new L.Point(60, 75),
});

const iconTripAdvisor = new L.Icon({
  iconUrl: tripadvisor.src,
  iconAnchor: [30, 55],
  popupAnchor: [0, -20],
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: new L.Point(60, 75),
});
const iconActivity = new L.Icon({
  iconUrl: activity.src,
  iconAnchor: [15, 22.5],
  popupAnchor: [0, -20],
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: new L.Point(30, 37.5),
});

const iconGreengo = new L.Icon({
  iconUrl: greengo.src,
  iconAnchor: [30, 55],
  popupAnchor: [0, -20],
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: new L.Point(60, 75),
});

const iconAirbnb = new L.Icon({
  iconUrl: airbnb.src,
  iconAnchor: [30, 55],
  popupAnchor: [0, -20],
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: new L.Point(60, 75),
});

const iconVillageFrance = new L.Icon({
  iconUrl: villageFrance.src,
  iconAnchor: [30, 55],
  popupAnchor: [0, -20],
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: new L.Point(60, 75),
});

const iconMuseum = new L.Icon({
  iconUrl: museum.src,
  iconAnchor: [8, 8],
  popupAnchor: [0, -8],
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: new L.Point(16, 16),
});

export {
  iconDolcevia,
  iconBooking,
  iconTripAdvisor,
  iconVillageFrance,
  iconGreengo,
  iconMuseum,
  iconAirbnb,
  iconActivity,
};
